import { GeoJsonLayer } from "@deck.gl/layers";

export class SitesGeoJsonLayer extends GeoJsonLayer {}

SitesGeoJsonLayer.layerName = "SitesGeoJsonLayer";
